document.addEventListener("DOMContentLoaded", () => {
    // Livewire 3 hook for element updates
    if (window.Livewire) {
        Livewire.hook('element.updated', (el, component) => {
            // Re-initialize Alpine components if needed
            if (window.Alpine && window.Alpine.discoverUninitializedComponents) {
                window.Alpine.discoverUninitializedComponents((el) => {
                    window.Alpine.initializeComponent(el);
                });
            }
        });
    }
});
